export const LOGIN_BENEFITS = ['See your whole order', 'See the full site address', 'See the site contact details'];
